import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  segmentItem: (props) => ({
    backgroundColor: 'transparent',
    borderRadius: `${theme.sizes.radius}px`,
    color: props.type === 1 ? theme.colors.gray.normal : (props.type === 2 ? theme.colors.text.normal : ''),
    border: 'none',
    height: '37px !important',
    margin: '1.5px',
    '&.selected': {
      backgroundColor: props.type === 1 ? theme.colors.background.normal : (props.type === 2 ? theme.colors.text.normal : ''),
      color: props.type === 1 ? theme.colors[props.color].normal : (props.type === 2 ? theme.colors.text.text : ''),
      boxShadow: `
        0 2px 8px 0 ${theme.colors.background.shadow}
      `,
    },
  }),
}));

export default useStyle;
